import { render, staticRenderFns } from "./NormalQuestionItem.vue?vue&type=template&id=3d297eac&scoped=true"
import script from "./NormalQuestionItem.vue?vue&type=script&lang=js"
export * from "./NormalQuestionItem.vue?vue&type=script&lang=js"
import style0 from "./NormalQuestionItem.vue?vue&type=style&index=0&id=3d297eac&prod&lang=less"
import style1 from "./NormalQuestionItem.vue?vue&type=style&index=1&id=3d297eac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d297eac",
  null
  
)

export default component.exports